export function createConnectToStoreDecorator(store: any) {
  return function connectToStore(selector: (state: any) => any) {
    return (target: any, propertyKey: string): void => {
      Object.defineProperty(target, propertyKey, {
        get() {
          return this[`__${propertyKey}`];
        },
        set(newVal) {
          if (this[`__${propertyKey}`] !== newVal) {
            this[`__${propertyKey}`] = Array.isArray(newVal)
              ? [...newVal] // 🔥 Clonar array para cambiar referencia
              : typeof newVal === "object" && newVal !== null
                ? { ...newVal } // 🔥 Clonar objetos también
                : newVal;
            this.requestUpdate(propertyKey);
          }
        },
        configurable: true,
        enumerable: true,
      });

      const connectedCallback = target.connectedCallback;
      const disconnectedCallback = target.disconnectedCallback;

      target.connectedCallback = function () {
        if (connectedCallback) {
          connectedCallback.call(this);
        }

        // Set initial state value (con nueva referencia)
        this[propertyKey] = selector(store.getState());

        this[`__unsubscribe__${propertyKey}`] = store.subscribe(() => {
          const newValue = selector(store.getState());
          this[propertyKey] = Array.isArray(newValue)
            ? [...newValue] // 🔥 Clonar para evitar referencias iguales
            : typeof newValue === "object" && newValue !== null
              ? { ...newValue }
              : newValue;
        });
      };

      target.disconnectedCallback = function () {
        if (disconnectedCallback) {
          disconnectedCallback.call(this);
        }
        if (this[`__unsubscribe__${propertyKey}`]) {
          this[`__unsubscribe__${propertyKey}`]();
        }
      };
    };
  };
}
